import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__container" }
const _hoisted_3 = { class: "container container-skeleton" }

import { ElSkeleton, ElSkeletonItem } from 'element-plus';
import { skeletonCads } from '../constants';
import DetailSkeleton from './DetailSkeleton.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SkeletonLaboratory',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header__animation" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ElSkeleton), {
          class: "header__container__skeleton skeleton",
          animated: ""
        }, {
          template: _withCtx(() => [
            _createVNode(_unref(ElSkeletonItem), {
              variant: "p",
              class: "skeleton__back"
            }),
            _createVNode(_unref(ElSkeletonItem), {
              variant: "p",
              style: {"width":"527px","height":"120px","border-radius":"8px"},
              class: "skeleton__text"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(ElSkeleton), {
        class: "header__mobile-block",
        animated: ""
      }, {
        template: _withCtx(() => [
          _createVNode(_unref(ElSkeletonItem), {
            class: "header__mobile-block__item",
            variant: "p"
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("main", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(skeletonCads), ({ id, size }) => {
        return (_openBlock(), _createBlock(DetailSkeleton, {
          key: id,
          size: size
        }, null, 8, ["size"]))
      }), 128))
    ])
  ], 64))
}
}

})